module.exports = __webpack_public_path__ + "img/Emmalee_handwrite.1c22e06e.png";